export const PERMISSION_TYPE = {
  MENU: "MENU",
  API: "API",
};
